import { formatDate } from '../../../../../utils/dateFormat';
export { formatDate };

// Memoized status renderer with optimized styling
export const renderStatus = (value) => {
  const statusStyles = {
    'ARRIVED': 'bg-green-100 text-green-800',
    'ACTIVE': 'bg-green-100 text-green-800',
    'DEMOBILIZED': 'bg-blue-100 text-blue-800',
    'IDLE': 'bg-yellow-100 text-yellow-800',
    'PENDING': 'bg-gray-100 text-gray-800'
  };
  
  const style = statusStyles[value?.toUpperCase()] || 'bg-gray-100 text-gray-800';
  
  return (
    <span className={`px-2 py-1 rounded-full text-base ${style}`}>
      {value || "Pending"}
    </span>
  );
};

// Memoized columns configuration (moved outside component to prevent recreation)
export const DEMOBILIZATION_COLUMNS = [
  { key: 'serial', title: 'S.NO.', searchable: false },
  { key: 'point_of_hire', title: 'POINT OF HIRE', searchable: true },
  { key: 'candidate_id', title: 'EMPLOYEE ID', searchable: true },
  { key: 'name', title: 'EMPLOYEE NAME', searchable: true },
  { key: 'nationality', title: 'NATIONALITY', searchable: true },
  { key: 'actual_profession', title: 'ACTUAL PROFESSION', searchable: true },
  { key: 'visa_profession', title: 'VISA PROFESSION', searchable: true },
  { key: 'client', title: 'CLIENT', searchable: true },
  { key: 'visa_provider', title: 'VISA PROVIDER', searchable: true },
  { key: 'border_number', title: 'BORDER NUMBER', searchable: true },
  { key: 'iqama_number', title: 'IQAMA NUMBER', searchable: true },
  { 
    key: 'arrival_date', 
    title: 'ARRIVAL DATE', 
    searchable: true,
    render: formatDate
  },
  { 
    key: 'mobilization_date', 
    title: 'MOBILIZATION DATE', 
    searchable: true,
    render: formatDate
  },
  { 
    key: 'status', 
    title: 'STATUS', 
    searchable: true,
    render: renderStatus
  },
  { key: 'select', title: 'SELECT', searchable: false }
];

// Constants for better maintainability
export const DEMOBILIZATION_CONFIG = {
  API_ENDPOINT: "/mobilization/demobilize",
  DOWNLOAD_ENDPOINT: "/mobilization/demobilize/download",
  DOWNLOAD_FILENAME: "Demobilization_Report",
  SEARCH_PLACEHOLDER: "Search across all columns...",
  NO_DATA_MESSAGE: "No demobilization data available",
  DEBOUNCE_MS: 300,
  DEFAULT_PAGE_SIZE: 50,
  PAGE_SIZE_OPTIONS: [50, 100, 500, 1000]
};

// Memoized searchable fields derived from columns
export const DEMOBILIZATION_SEARCHABLE_FIELDS = DEMOBILIZATION_COLUMNS
  .filter(col => col.searchable)
  .map(col => col.key);

// ERE status constants for selection validation
export const ERE_STATUSES = [
  "ON ERE", 
  "ERE EXTENSION", 
  "NOT RETURN FROM ERE", 
  "ERE EXTENSION-PAYMENT DONE", 
  "'ON ERE EXTENSION_ISSUED", 
  "ON ERE-ANNUAL VACATION", 
  "ON ERE-ANNUAL VACATION-PAYMENT DONE"
];